/**
 * An `InternalDataLayer` class is a class meant to be used internally by the `Tracker`.
 * It is used to temporarily store GA4 events
 * that were pushed to the `dataLayer` for the current page view.
 */
export class InternalDataLayer {
    constructor() {
        this.events = new Set();
        this.isPageViewTracked = false;
        this.add = (event, payload) => {
            this.events.add({ event, ...payload });
        };
        this.clear = () => {
            this.events.clear();
            this.isPageViewTracked = false;
        };
        this.trackPageView = () => {
            this.isPageViewTracked = true;
        };
    }
}
//# sourceMappingURL=internal-data-layer.js.map